var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DndContext, closestCenter } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, arrayMove, useSortable, } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { RoundedButton } from 'components/Forms/Fields';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import Select from '../Forms/Fields/ReusableSelect';
import { IOItem, IOItemColumn, IOItemRow, } from 'containers/StructureBuilderPage/styles';
import produce from 'immer';
import { useState, useEffect } from 'react';
function SortableItem(_a) {
    var id = _a.id, children = _a.children;
    var _b = useSortable({ id: id }), attributes = _b.attributes, listeners = _b.listeners, setNodeRef = _b.setNodeRef, transform = _b.transform, transition = _b.transition;
    var style = {
        transform: CSS.Transform.toString(transform),
        transition: transition,
        display: 'flex',
        flexDirection: 'row',
    };
    return (_jsxs("div", __assign({ ref: setNodeRef, style: style }, { children: [_jsx("div", __assign({}, attributes, listeners, { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '80px',
                    cursor: 'grab',
                    padding: '4px',
                    userSelect: 'none',
                } }, { children: "\u2630" })), _jsx("div", __assign({ style: { width: '230px' } }, { children: children }))] })));
}
export default function SortableList(_a) {
    var data = _a.data, groups = _a.groups, patchSettings = _a.patchSettings, _b = _a.listItems, listItems = _b === void 0 ? [] : _b, handleSettingsChange = _a.handleSettingsChange, deleteEdge = _a.deleteEdge;
    var _c = useState(listItems || []), items = _c[0], setItems = _c[1];
    useEffect(function () {
        setItems(listItems);
    }, [listItems]);
    var handleDragEnd = function (event) {
        var active = event.active, over = event.over;
        if (!over || active.id === over.id)
            return;
        setItems(function (prevItems) {
            var oldIndex = prevItems.indexOf(active.id);
            var newIndex = prevItems.indexOf(over.id);
            var newOrder = arrayMove(prevItems, oldIndex, newIndex);
            handleSettingsChange({ items: newOrder });
            return newOrder;
        });
    };
    return (_jsx(DndContext, __assign({ collisionDetection: closestCenter, onDragEnd: handleDragEnd }, { children: _jsx(SortableContext, __assign({ items: items, strategy: verticalListSortingStrategy }, { children: items.map(function (id) {
                var _a, _b;
                var item = data.find(function (d) { return d.id === id; }) || {};
                return (_jsxs(IOItem, __assign({ style: { marginBottom: 0 }, menuItem: true }, { children: [_jsx(IOItemColumn, { children: _jsxs(SortableItem, __assign({ id: id }, { children: [_jsx(IOItemRow, { children: _jsx("span", __assign({ style: { flex: '1' } }, { children: item === null || item === void 0 ? void 0 : item.name })) }), _jsx(IOItemRow, __assign({ menuItem: true }, { children: _jsx(Select, { value: (_a = (groups &&
                                                groups
                                                    .filter(function (i) {
                                                    var _a, _b;
                                                    return ((_b = (_a = patchSettings === null || patchSettings === void 0 ? void 0 : patchSettings.groups) === null || _a === void 0 ? void 0 : _a[item.to_patch]) !== null && _b !== void 0 ? _b : []).includes(i.id);
                                                })
                                                    .map(function (group) {
                                                    var _a;
                                                    return ({
                                                        value: group.id,
                                                        label: (_a = group.name) !== null && _a !== void 0 ? _a : group.id,
                                                    });
                                                }))) !== null && _a !== void 0 ? _a : [], onChange: function (options) {
                                                handleSettingsChange(produce(patchSettings, function (newSettings) {
                                                    if (!newSettings.groups) {
                                                        newSettings.groups = {};
                                                    }
                                                    if (!options || options.length === 0) {
                                                        var _a = patchSettings.groups, _b = item.to_patch, __ = _a[_b], // remove the empty key
                                                        rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]) // keep only the remaining keys
                                                        ;
                                                        newSettings.groups = rest;
                                                        return;
                                                    }
                                                    newSettings.groups[item.to_patch] = options.map(function (option) { return option.value; });
                                                }));
                                            }, options: (_b = (groups &&
                                                groups.map(function (group) {
                                                    var _a;
                                                    return ({
                                                        value: group.id,
                                                        label: (_a = group.name) !== null && _a !== void 0 ? _a : group.id,
                                                    });
                                                }))) !== null && _b !== void 0 ? _b : [], multiple: true, isMulti: true, placeholder: "Filter with groups..." }) }))] }), id) }), _jsx(RoundedButton, { square: true, small: true, discreet: true, noMargin: true, icon: faTimes, onClick: function () { return deleteEdge(item, false); } })] }), item.id));
            }) })) })));
}
